import { gql } from '@apollo/client'

export default gql(`
    mutation updateAssetCreditLinks($input: [UpdateCreditLinkInput] $assetId: ID $project:String $module: String) {
        updateAssetCreditLinks(
            input: $input
            assetId: $assetId
            project: $project
            module: $module
        ){
            id
        }
    }`
)
